export const altNormativa='Normativa'
export const altDesig='Designaciones'
export const altWeb='Web'
export const altCSV='Estructura y Autoridades - Descarga CSV (Delimitado por comas)'
export const altXLS='Estructura y Autoridades - Descarga XLS'
export const altPDF='Estructura y Autoridades - Descarga PDF (Solo desde Chrome)'
export const altOrgPDF='Estructura Orgánica. Formato PDF'
export const altEsc='Organigrama Escalar de'
